module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-Demi.553decd4.otf";